import React, { useEffect, useState } from 'react'
import { getCases, editCase } from '../../Web Apis/webApis'
import Load from '../Load/Load'
import { message, Pagination, Tooltip } from 'antd'
import { AiFillDelete, AiFillEdit, AiOutlineEye } from "react-icons/ai";

import {  FaFileCirclePlus } from "react-icons/fa6";

import ViewCase from './ViewCase';
import EditCase from './EditCase';
import Report from './Report';
import { Color } from 'antd/es/color-picker';


const Cases = () => {
    const [loading, setLoading] = useState(false)
    const [allCases, setAllCases] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(0)
    const [totalElements, setTotalElements] = useState('')
    const [action, setAction] = useState(false)

    const [showViewModal, setShowViewModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [showReportModal, setShowReportModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState({})


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };


    const fetchCases = async () => {
        try {
            setLoading(true)
            setAllCases([])


            const sendPage = currentPage - 1

            const response = await getCases(sendPage, itemsPerPage)

            if(response?.data?.success){
                setAllCases(response?.data?.data?.content)
                setTotalPages(response?.data?.data?.totalPages)
                setTotalElements(response?.data?.data?.totalElements)
            }

        } catch (error) {
            console.log("Error while fetch relation category", error.message)
            if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                // Handle internet disconnection
                return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
                window.alert("Your account is logged in to another device, please login again !")
                localStorage.clear();
                window.location.href = "/login"
            }
            if (error?.response?.status === 500) {
                message.error("Server not responding")
            } else {
                return;
            }
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        fetchCases()
    }, [currentPage, action])


    const handleViewModalOpen = async (item) => {
        if(item?.status === "Pending"){
            const caseStatus = "In Progress"
            const response = await editCase(item?.id , caseStatus)
            if(response?.data?.success){
                message.success("Case status updated as case is in progress")
                setAction(!action)
            }
        }
        setSelectedItem(item)
        setShowViewModal(true)
    }

    const handleUpdateModalOpen = (item) => {
        setSelectedItem(item)
        setShowEditModal(true)
    }

    const hanldeReportOpen = (item) => {
        setSelectedItem(item)
        setShowReportModal(true)
    }


    return (
        <div className='p-4 mt-16'>

            <div className="flex justify-between items-center w-full space-x-4">

                {/* Search Input Container */}
                <div className="relative flex items-center">
                    <h2 className='text-3xl font-bold'>Medical Cases Management</h2>

                </div>


                {/* Create Button */}
                {/* <button
                    onClick={handleCreateModalOpen}
                    className="bg-gradient-to-br from-blue-500 to-gray-500 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded"
                >
                    Add Clinic
                </button> */}
            </div>



            <div>
                <table className='min-w-full mt-7 bg-gradient-to-br from-teal-600 to-teal-200 border border-b-4 border-black'>
                    <thead>
                        <tr>
                            <th className="py-2 px-4 border-b text-center">S.No</th>
                            <th className="py-2 px-4 border-b text-center">Owner's Surname</th>
                            <th className="py-2 px-4 border-b text-center">Patient Name</th>
                            <th className="py-2 px-4 border-b text-center">Patient Breed</th>
                            <th className="py-2 px-4 border-b text-center">Case Status</th>
                            <th className="py-2 px-4 border-b text-center">Case Type</th>
                            <th className="py-2 px-4 border-b text-center">Case Opinion</th>
                            <th className="py-2 px-4 border-b text-center">Condition</th>
                            <th className="py-2 px-4 border-b text-center">Submitted By</th>
                            <th className="py-2 px-4 border-b text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                    {allCases?.length > 0 ? (
                    allCases?.map((item, index) => (
                        <tr key={item.id}
                            className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
                        >
                            <td className='py-2 px-4 border-b'>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                            <td className="py-2 px-4 border-b">{item?.surName}</td>
                            <td className="py-2 px-4 border-b">{item?.patientName}</td>
                            <td className="py-2 px-4 border-b">{item?.patientBreed}</td>


                            <td className={`py-2 px-4 border-b font-bold ${item?.status === "Pending" ? "text-red-700"
                                                                : item?.status === "In Progress" ? "text-orange-500"
                                                                : item?.status === "Completed" ? "text-green-500"
                                                                : ""
                            }`}>{item?.status}</td>
                            <td className="py-2 px-4 border-b">{item?.caseType}</td>
                            <td className="py-2 px-4 border-b">{item?.caseOpinon}</td>
                            
                            <td className={`py-2 px-4 border-b font-bold ${item?.urgent === 'Yes' ? "text-red-700" : "text-green-600"}`}>{item?.urgent === 'Yes' ? "Urgent" : "Not Urgent" }</td>
                            <td className="py-2 px-4 border-b">{item?.userFirstName} {item?.userLastName}</td>
                            <td className="py-2 px-4 border-b ">
                                              <div className="flex flex-row justify-center ">
                                                
                                                <button
                                                  onClick={() => handleViewModalOpen(item)}
                                                  className="text-blue-500 hover:text-blue-700 flex items-center"
                                                >
                                                  <AiOutlineEye className="mr-1 text-2xl" />
                                                </button>
                                                 <button
                                                   onClick={() => handleUpdateModalOpen(item)}
                                                   className="mr-2 text-blue-500 hover:text-blue-700 flex items-center"
                                                 >
                                                   <AiFillEdit className="mr-1 text-2xl" />
                                                </button>
                                                <Tooltip title="Upload and View Report">
                                                <button
                                                  onClick={() => hanldeReportOpen(item)}
                                                  className="text-red-500 hover:text-red-700 flex items-center"
                                                >
                                                  <FaFileCirclePlus className="mr-1 text-2xl" />
                                                </button>
                                                </Tooltip>

                                                {/* <Tooltip title="View Report">
                                                <button
                                                  onClick={() => hanldeReportOpen(item)}
                                                  className="text-green-500 hover:text-green-700 flex items-center"
                                                >
                                                  <FaFileCircleCheck className="mr-1 text-2xl" />
                                                </button>
                                                </Tooltip> */}
                                              </div>
                                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="7" className=' px-4 py-4 border-b text-center font-bold'>No case data found</td>
                    </tr>
                )}

                    

                    </tbody>
                    {loading && <Load />}
                </table>
               

                <div className="mt-4 flex justify-end">
                    <Pagination
                      current={currentPage}
                      total={totalElements}
                      pageSize={itemsPerPage}
                      onChange={handlePageChange}
                      showSizeChanger={false}
                    />
                  </div>


                  {showViewModal && (
                    <ViewCase
                    showModal={showViewModal}
                    setShowModal={setShowViewModal}
                    selectedCase={selectedItem}
                    />
                  )}

                  {showEditModal && (
                    <EditCase
                    showModal={showEditModal}
                    setShowModal={setShowEditModal}
                    selectedCase={selectedItem}
                    action={action}
                    setAction={setAction}
                    />
                  )}


                  {showReportModal && (
                    <Report
                    showModal={showReportModal}
                    setShowModal={setShowReportModal}
                    action={action}
                    setAction={setAction}
                    selectedCase={selectedItem}
                    />
                  )}


            </div>
        </div>
    )
}

export default Cases